module.exports = __webpack_public_path__ + "img/arctic-circle-logo.71c91b02.svg";